module.exports = __webpack_public_path__ + "static/media/KaTeX_Main-BoldItalic.a2e3dcd2.woff";